import styled from "@emotion/styled";
import { MDSTextField } from "@/mds";

export const FilterField = styled(MDSTextField)`
  padding: ${({ theme }) => `${theme.spacing["2"]} ${theme.spacing["3"]}`};
  min-height: 32px;
  input {
    padding-block: 0px;
  }
`;
